import type { MutationOptions } from "@tanstack/react-query";

/**
 * How every write runs: sent at once, whether or not the browser thinks it is online.
 *
 * The library's default holds a write while the browser reports no network,
 * and every write queued behind it in the same scope, with nothing on screen
 * and no request sent: an edit made in that gap looks done and is lost on
 * reload. Sent anyway, a write that cannot reach the server fails, and its
 * editor says so and offers to send it again.
 */
export const WRITE_DEFAULTS = {
  networkMode: "always",
} as const satisfies MutationOptions;
